import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 1a1 1 0 1 0 0 2h3.586l-4.293 4.293a1 1 0 0 0 1.414 1.414L21 4.414V8a1 1 0 1 0 2 0V2a1 1 0 0 0-1-1zM1 8a1 1 0 0 0 2 0V4.414l4.293 4.293a1 1 0 0 0 1.414-1.414L4.414 3H8a1 1 0 0 0 0-2H2a1 1 0 0 0-1 1zM8 23a1 1 0 1 0 0-2H4.414l4.293-4.293a1 1 0 1 0-1.414-1.414L3 19.586V16a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1zM23 16a1 1 0 1 0-2 0v3.586l-4.293-4.293a1 1 0 0 0-1.414 1.414L19.586 21H16a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }